import type { VariantProps } from "class-variance-authority";
import { cva } from "class-variance-authority";
import { cn } from "../../../lib";
import DescriptionItem, { DescriptionItemProps } from "./Descriptions.Item";

const descriptionsVariants = cva("descriptions grid gap-2.5", {
  variants: {
    color: {
      default: "text-black",
    },
    columns: {
      default: "lg:grid-cols-1",
      two: "lg:grid-cols-2",
      three: "lg:grid-cols-3",
      four: "lg:grid-cols-4",
    },
    mobileColumns: {
      default: "grid-cols-1",
      two: "grid-cols-2",
    },
  },
  defaultVariants: {
    columns: "default",
    mobileColumns: "default",
  },
});

interface DescriptionsProps extends VariantProps<typeof descriptionsVariants> {
  items?: DescriptionItemProps["item"][] | undefined;
  layoutDirection?: "vertical" | "horizontal";
  className?: string;
  children?: React.ReactNode;
}

const Descriptions = (props: DescriptionsProps) => {
  const {
    columns = "default",
    mobileColumns = "default",
    color = "default",
    layoutDirection = "horizontal",
    items = [],
    className,
    children,
  } = props;
  return (
    <div
      className={cn(
        descriptionsVariants({ columns, mobileColumns, color }),
        className,
      )}
    >
      {items.map((item, index) => (
        <DescriptionItem
          item={item}
          key={index}
          layoutClass={layoutDirection}
        />
      ))}

      {children}
    </div>
  );
};

Descriptions.displayName = "Descriptions";

export default Descriptions;
export { descriptionsVariants };
export type { DescriptionsProps };
